export default "__VITE_ASSET__DzBEhQCa__"